// src/api/stickers.js
//
// API страницы стикеров. 🔴 Печатный файл здесь НЕ запрашивается и не
// принимается: публичный API отдаёт только `mockup_file` (см.
// backend/src/controllers/stickerController.js).
import client from './client.js';

export const stickersAPI = {
  getCategories: () => client.get('/stickers/categories'),
  getList: (params) => client.get('/stickers', { params }),
};
